import { combineEpics } from 'redux-observable'
import * as localeEpic from './localeEpic'
import * as redirectEpic from './redirectEpic'
import * as analyticsEpic from './analyticsEpic'
import * as planEpic from './planEpic'
import * as applicationEpic from './applicationEpic'
import * as authEpic from './authEpic'
import * as debugEpic from './debugEpic'
import * as memberEpic from './memberEpic'
import * as appEpic from './appEpic'
import * as brokerEpic from './brokerEpic'

// Use Object.values as otherwise can't destruct properly as the epics are es6 modules
export default combineEpics(
  ...Object.values({
    ...appEpic,
    ...localeEpic,
    ...redirectEpic,
    ...authEpic,
    ...planEpic,
    ...memberEpic,
    ...applicationEpic,
    ...brokerEpic,
    ...debugEpic,
    ...analyticsEpic
  })
)
